$(function () {
  $(".js-minerva-form-expandable").on('click', function () {
    var $this = $(this);

    if ($this.hasClass("collapsed")) {
      $this.removeClass("collapsed");
    } else {
      $this.addClass("collapsed");
    }
  });
});



// WEBPACK FOOTER //
// lib/js/minerva-form/expandable.js